"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsBinanceClient = void 0;
const constants_1 = require("../config/constants");
const localStorage_1 = require("../utils/misc/localStorage");
const shared_1 = require("./shared");
class WsBinanceClient extends shared_1.WsNetworkClient {
    constructor(params) {
        const { refreshFunction, getListenKeyFunction, listenKey, listenKeyRefreshInterval = shared_1.LISTEN_KEY_REFRESH_INTERVAL, socket, _autoReconnect = true, cacheInstanceName, reqParams } = params;
        super(Object.assign(Object.assign({}, params), { wsUrl: `${params.baseUrl}/ws/${listenKey}`, socket }));
        this._listenKeyAutoRefresh = false;
        this._cacheInstanceName = cacheInstanceName;
        this._listenKey = listenKey;
        this._listenKeyRefreshIntervalTime = listenKeyRefreshInterval;
        this._refreshFunction = refreshFunction;
        this._getListenKeyFunction = getListenKeyFunction;
        this._autoReconnect = _autoReconnect;
        this._reqParams = reqParams;
        this.on(shared_1.EWsEventsTypes.CONNECTION_BROKEN, (e) => {
            if (this._autoReconnect)
                this.reinit();
        });
        this.setListenKeyRefreshInterval(refreshFunction);
    }
    clearListenKeyRefreshInterval() {
        clearInterval(this._listenKeyRefreshInterval);
    }
    static checkIfCachedKeyValid(keytime) {
        return new Date().getTime() - keytime < constants_1.THIRTY_MINUTES_IN_MS;
    }
    static getCachedListenKey(cacheName) {
        const saved = localStorage_1.LocalStorageClient.getListenKey(cacheName);
        if (saved && WsBinanceClient.checkIfCachedKeyValid(saved.savedTime)) {
            return saved;
        }
        return undefined;
    }
    static setCachedListenKey(cacheName, key) {
        if (cacheName) {
            localStorage_1.LocalStorageClient.setListenKey(cacheName, key);
            localStorage.setItem('set', 'set');
        }
    }
    static createQueryString(params) {
        if (!params)
            return '';
        const queryEntries = Object.entries(params)
            .map(([key, value]) => `${key}=${encodeURIComponent(value.toString())}`);
        return `?${queryEntries.join('&')}`;
    }
    getListenKey() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._getListenKeyFunction)
                throw new Error('listen key could not be fetched');
            if (this._cacheInstanceName === undefined)
                throw new Error('unnamed instance');
            const cachedKey = WsBinanceClient.getCachedListenKey(this._cacheInstanceName);
            if (cachedKey) {
                this._listenKey = cachedKey.listenKey;
                return cachedKey.listenKey;
            }
            else {
                const listenKeyResponse = yield this._getListenKeyFunction();
                WsBinanceClient.setCachedListenKey(this._cacheInstanceName, {
                    savedTime: new Date().getTime(),
                    listenKey: listenKeyResponse.listenKey
                });
                return listenKeyResponse.listenKey;
            }
        });
    }
    reinit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clearListenKeyRefreshInterval();
            this.deactivate();
            if (this._getListenKeyFunction) {
                this.setStatus(shared_1.EWebSocketClientStatus.LOADING);
                const listenKey = yield this.getListenKey();
                this._listenKey = listenKey;
                const queryString = WsBinanceClient.createQueryString(this._reqParams);
                this._wsUrl = `${this._baseUrl}/ws/${this._listenKey}${queryString}`;
                this.setListenKeyRefreshInterval(this._refreshFunction);
                this._socket = yield WsBinanceClient.initSocket(this._wsUrl);
                this._socket.onopen = null;
                this.initSocketListeners();
                return Promise.resolve();
            }
            else {
                return Promise.reject('Could not get listen key');
            }
        });
    }
    static load(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { getListenKeyFunction, listenKey, baseUrl, cacheInstanceName } = params;
            let listenKeyToInit;
            if (Boolean(listenKey)) {
                listenKeyToInit = listenKey;
            }
            else if (typeof getListenKeyFunction === 'function') {
                let listenKeyFetched;
                if (cacheInstanceName) {
                    const cachedKey = WsBinanceClient.getCachedListenKey(cacheInstanceName);
                    if (cachedKey) {
                        listenKeyFetched = cachedKey.listenKey;
                    }
                }
                if (listenKeyFetched === undefined) {
                    listenKeyFetched = (yield getListenKeyFunction()).listenKey;
                    if (cacheInstanceName) {
                        WsBinanceClient.setCachedListenKey(cacheInstanceName, {
                            savedTime: new Date().getTime(),
                            listenKey: listenKeyFetched
                        });
                    }
                }
                listenKeyToInit = listenKeyFetched;
            }
            if (listenKeyToInit) {
                const socket = yield WsBinanceClient.initSocket(`${params.baseUrl}/ws/${listenKeyToInit}`);
                return new WsBinanceClient(Object.assign(Object.assign({}, params), { baseUrl: baseUrl, listenKey: listenKeyToInit, socket }));
            }
            else
                throw new Error('Either listen key or listen key getter should be specified');
        });
    }
    setListenKeyRefreshInterval(refreshFunction) {
        if (!this._listenKeyAutoRefresh)
            return;
        this._listenKeyRefreshInterval = setInterval(() => __awaiter(this, void 0, void 0, function* () {
            let refreshStatus = {
                status: 0,
            };
            try {
                this.reinit();
                // refreshStatus = await refreshFunction(this._listenKey)
                // if (refreshStatus.status !== 200) throw new Error('Listen key could not be refreshed')
            }
            catch (_a) {
                try {
                    this.reinit();
                    return;
                }
                catch (error) {
                    throw error;
                }
            }
        }), this._listenKeyRefreshIntervalTime);
    }
    subscribeMarkPriceStream(symbol) {
        if (symbol.length === 0)
            return;
        this.subscribeStream(symbol.map(s => `${s.toLowerCase()}@markPrice`)); // 3s default, optional @1s refresh interval
    }
    unsubscribeMarkPriceStream(symbol) {
        if (symbol.length === 0)
            return;
        this.unsubscribeStream(symbol.map(s => `${s.toLowerCase()}@markPrice`));
    }
    subscribeIndividualTickerStream(symbol) {
        if (symbol.length === 0)
            return;
        this.subscribeStream(symbol.map(s => `${s.toLowerCase()}@ticker`)); //1s refresh interval
    }
    unsubscribeIndividualTickerStream(symbol) {
        if (symbol.length === 0)
            return;
        this.unsubscribeStream(symbol.map(s => `${s.toLowerCase()}@ticker`));
    }
    deactivate() {
        if (this.getStatus() === shared_1.EWebSocketClientStatus.DEACTIVATED)
            return;
        this.clearListenKeyRefreshInterval();
        super.deactivate();
    }
}
exports.WsBinanceClient = WsBinanceClient;
